/* Build Your Bundle — takeover UI behaviour.
   Config (shipping/travel/LBB values, discount code) is read from data-* on the root. */
(function () {
  // Lightweight, dependency-free confetti burst (canvas). Fired on a bonus unlock.
  function bybConfetti(originEl) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var dpr = window.devicePixelRatio || 1;
    var canvas = document.createElement('canvas');
    var cs = canvas.style;
    cs.position = 'fixed'; cs.left = '0'; cs.top = '0'; cs.width = '100%'; cs.height = '100%';
    cs.pointerEvents = 'none'; cs.zIndex = '99999';
    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');

    var ox = window.innerWidth / 2, oy = window.innerHeight * 0.28;
    if (originEl && originEl.getBoundingClientRect) {
      var r = originEl.getBoundingClientRect();
      if (r.width) { ox = r.left + r.width / 2; oy = r.top + r.height / 2; }
    }
    var colors = ['#003a66', '#C3E5FF', '#9fd4ff', '#C20000', '#ffd34d', '#ffffff'];
    var parts = [];
    for (var i = 0; i < 90; i++) {
      var ang = Math.random() * Math.PI * 2;
      var spd = (4 + Math.random() * 7) * dpr;
      parts.push({
        x: ox * dpr, y: oy * dpr,
        vx: Math.cos(ang) * spd,
        vy: Math.sin(ang) * spd - 4 * dpr,
        g: (0.18 + Math.random() * 0.12) * dpr,
        w: (5 + Math.random() * 6) * dpr,
        h: (7 + Math.random() * 6) * dpr,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.3,
        color: colors[(Math.random() * colors.length) | 0]
      });
    }
    var start = null, DURATION = 1600;
    function frame(t) {
      if (start === null) start = t;
      var elapsed = t - start;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var alpha = Math.max(0, 1 - elapsed / DURATION);
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.vy += p.g; p.x += p.vx; p.y += p.vy; p.rot += p.vr;
        ctx.save();
        ctx.globalAlpha = alpha;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      }
      if (elapsed < DURATION) requestAnimationFrame(frame);
      else if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
    }
    requestAnimationFrame(frame);
  }

  // ── Build Your Bundle free-gift logic (Gift Logic spec v1.0) ─────────────────────────────
  // KEEP IN SYNC with the identical function in build-your-bundle-v3.js. Single source of truth
  // for how many gifts a cart earns and which ones, so V1/V2/V3 can never drift apart.
  //   • Free shipping: 1+ Clean Towel OR 2+ Makeup Wipes.
  //   • Quantity gifts: foundation count (wipes + towels) — 6+ → 2, 4+ → 1, else 0.
  //   • A container adds +1 and an extra adds +1 on top; the total is capped at 2.
  //   • Fixed order (no customer choice): gift #1 is always DermaDot, gift #2 is always Travel.
  //   • The Luxe Bamboo Box's 50 free towels are a separate bonus, outside the 2-gift cap.
  function computeBybGifts(input) {
    var wipeQty = input.wipeQty || 0;
    var towelQty = input.towelQty || 0;
    var freeShipping = towelQty >= 1 || wipeQty >= 2;
    var foundationCount = wipeQty + towelQty;
    var qtyGifts = foundationCount >= 6 ? 2 : (foundationCount >= 4 ? 1 : 0);
    var addOnGifts = (input.hasContainer ? 1 : 0) + (input.hasExtra ? 1 : 0);
    var totalGifts = Math.min(qtyGifts + addOnGifts, 2);
    var gifts = [];
    if (totalGifts >= 1) gifts.push('dermadot'); // 1st is always DermaDot
    if (totalGifts >= 2) gifts.push('travel');   // 2nd is always Travel
    return {
      freeShipping: freeShipping,
      foundationCount: foundationCount,
      totalGifts: totalGifts,
      gifts: gifts,
      luxeBonus: !!input.isLuxeBox
    };
  }
  // Map a bundle role to the fixed gift it grants. DermaDot rides the 'extra' slot, Travel the
  // 'container' slot (matches the section config), but identity is fixed by the spec, not the role.
  function giftKeyForRole(role) {
    if (role === 'extra') return 'dermadot';
    if (role === 'container') return 'travel';
    return null;
  }

  function initByb(root) {
    if (!root || root.getAttribute('data-byb-init') === 'true') return;
    root.setAttribute('data-byb-init', 'true');

    var cards = [].slice.call(root.querySelectorAll('.nc-product-card'));
    var addBtn = root.querySelector('[data-add]');
    if (!addBtn) return;
    var labelEmpty = addBtn.getAttribute('data-empty-label');
    var label = addBtn.getAttribute('data-label');
    var hintEl = root.querySelector('[data-hint]');
    var miniCart = root.querySelector('[data-mini-cart]');
    var emptyCart = root.querySelector('[data-empty-cart]');
    var gwpCollection = root.querySelector('[data-gwp-collection]');
    var gwpCountEl = root.querySelector('[data-gwp-unlocked-count]');
    var gwpTitleEl = root.querySelector('[data-gwp-title]');
    var gwpCards = gwpCollection ? [].slice.call(gwpCollection.querySelectorAll('.gwp-product-card')) : [];

    var titleSaveEl = root.querySelector('[data-title-save]');
    var savingsLineEl = root.querySelector('[data-savings-line]');
    var giftbar = root.querySelector('[data-giftbar]');
    var gifts = giftbar ? [].slice.call(giftbar.querySelectorAll('.prog_block')) : [];
    var bonusStrips = giftbar ? [].slice.call(giftbar.querySelectorAll('[data-bonus-strip]')) : [];
    var giftNumEl = giftbar ? giftbar.querySelector('[data-gift-num]') : null;
    var giftBonusEl = giftbar ? giftbar.querySelector('[data-gift-bonus]') : null;

    var subWrap = root.querySelector('[data-sub]');
    var subPct = subWrap ? parseFloat(subWrap.getAttribute('data-pct')) || 0 : 0;
    var subActive = !!subWrap;
    // Lock/unlock the subscribe / one-time toggle (used while a checkout redirect is in flight).
    function setSubDisabled(disabled) {
      if (!subWrap) return;
      subWrap.classList.toggle('is-checkout-loading', disabled);
      subWrap.querySelectorAll('input[type=radio]').forEach(function (r) { r.disabled = disabled; });
    }
    // Subscribe & Save badge: flat "EXTRA 20% OFF".
    if (subWrap) {
      var upToEl = subWrap.querySelector('.save-upto');
      if (upToEl) upToEl.textContent = 'EXTRA 20% OFF';
    }
    var shippingValue = parseInt(root.getAttribute('data-free-shipping-value'), 10) || 0;
    var travelValue = parseInt(root.getAttribute('data-free-travel-value'), 10) || 0;
    var lbbGiftValue = parseInt(root.getAttribute('data-lbb-value'), 10) || 0;
    var discountCode = root.getAttribute('data-discount-code') || '';
    // Cart line property identifying which bundle page built the cart (e.g. MURW_v1 / MURW_v2).
    var bundleId = root.getAttribute('data-bundle-id') || '';

    // Assigned by the wizard setup below (if the wizard layout is present) so update() can
    // keep the step nav / Continue buttons in sync as products are added or removed.
    var wizardRefresh = null;
    var wizardGoToLast = null;
    // Flag set right before the checkout redirect so that returning (via back) reopens the
    // last (review) step instead of step 1 — the built bundle is still in storage.
    var RETURN_KEY = 'byb-return:' + (window.location && window.location.pathname || 'byb');

    // Monotonic counter stamping the order gifts are picked, so the gift boxes fill in
    // selection order rather than DOM order (positions stay stable as you add more).
    var gwpPickSeq = 0;

    // ---- Session persistence: remember the built bundle across refreshes ----
    var STORAGE_KEY = 'byb-state:' + (window.location && window.location.pathname || 'byb');
    var restoring = false;
    function saveState() {
      if (restoring) return; // don't write while applying a restore
      try {
        var q = {};
        cards.forEach(function (c) {
          var n = qty(c);
          if (n > 0) q[c.getAttribute('data-variant-id')] = n;
        });
        var g = gwpCards.filter(function (card) {
          var btn = card.querySelector('[data-gwp-toggle]');
          return btn && !btn.disabled && btn.classList.contains('gwp--add') && card.getAttribute('data-gwp-variant');
        }).sort(function (a, b) {
          return (parseInt(a.getAttribute('data-pick-seq'), 10) || 0) - (parseInt(b.getAttribute('data-pick-seq'), 10) || 0);
        }).map(function (card) { return card.getAttribute('data-gift-key'); });
        window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ q: q, g: g, s: subActive }));
      } catch (e) {}
    }
    function restoreState() {
      var data;
      try { data = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null'); } catch (e) { data = null; }
      if (!data) return;
      restoring = true;
      if (data.q) {
        cards.forEach(function (c) {
          var n = data.q[c.getAttribute('data-variant-id')];
          if (n && c._setQtySilent) c._setQtySilent(n);
        });
      }
      if (data.g && data.g.length) {
        gwpCards.forEach(function (card) {
          var btn = card.querySelector('[data-gwp-toggle]');
          var idx = data.g.indexOf(card.getAttribute('data-gift-key'));
          if (btn && idx !== -1) {
            btn.classList.add('gwp--add');
            // Preserve the saved pick order (data.g is stored in selection order).
            card.setAttribute('data-pick-seq', String(idx + 1));
          }
        });
        gwpPickSeq = data.g.length;
      }
      if (subWrap && data.s === false) {
        var onetime = subWrap.querySelector('input[value="onetime"]');
        if (onetime) { onetime.checked = true; subActive = false; }
      }
      restoring = false;
    }

    function money(c) { return '$' + (c / 100).toFixed(2); }
    function savingsRow(label, amt) { return '<div class="byb-savings-row"><span>' + label + '</span><span class="byb-savings-amt">-' + money(amt) + '</span></div>'; }
    function qty(card) { return parseInt(card.getAttribute('data-qty') || '0', 10); }
    function roleQty(role) {
      var n = 0; cards.forEach(function (c) { if (c.getAttribute('data-role') === role) n += qty(c); }); return n;
    }
    function hasLbb() {
      return cards.some(function (c) {
        return c.getAttribute('data-role') === 'container' && qty(c) > 0 && c.getAttribute('data-featured') === 'true';
      });
    }
    // Total quantity of Luxe Bamboo (featured) containers — each one comes with 50 FREE Clean Towels.
    function lbbCount() {
      var n = 0;
      cards.forEach(function (c) {
        if (c.getAttribute('data-role') === 'container' && c.getAttribute('data-featured') === 'true') n += qty(c);
      });
      return n;
    }
    // Single source of truth for "is this gift/card unlocked?" — used by both the
    // gift bar and the pick-your-gift cards so the two never drift apart.
    // Volume rule: wipes alone can unlock gift tiers — 2+ wipes unlock the towel tier (Free
    // Shipping), 4+ wipes unlock the container tier — no towel/container needed.
    function wipeUnlocksTier(role) {
      var wipeQty = roleQty('murw');
      if (role === 'towel') return wipeQty >= 2;
      if (role === 'container') return wipeQty >= 4;
      return false;
    }
    function isUnlocked(role, threshold, count) {
      if (role === 'lbb') return hasLbb();
      if (wipeUnlocksTier(role)) return true;
      if (role && role !== 'none') return roleQty(role) > 0;
      if (threshold) return count >= threshold;
      return count > 0;
    }
    function bracket(s) {
      if (!s) return s;
      s = String(s).trim();
      if (s.charAt(0) === '[') return s;
      return '[' + s + ']';
    }
    var gwpTickSvg = '<svg class="gwp-tick" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5 10 17.5 19 7" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    // Gifts are auto-added, so the toggle is inert: show a "Added" tick on an earned gift and
    // hide the button entirely otherwise (no "+ Add FREE" affordance — spec §2).
    function syncGwpToggleBtn(btn) {
      var added = btn.classList.contains('gwp--add');
      btn.innerHTML = added ? (gwpTickSvg + '<span>Added</span>') : '';
      btn.style.display = added ? '' : 'none';
      btn.setAttribute('aria-label', added ? 'Free gift added' : 'Free gift locked');
    }
    function lockedHint(g, count) {
      var role = g.getAttribute('data-unlock-role');
      var threshold = parseInt(g.getAttribute('data-threshold'), 10) || 0;
      var custom = g.getAttribute('data-locked-text');
      if (custom) return bracket(custom);
      if (role && role !== 'none') {
        if (role === 'murw') return bracket('Add a Makeup Wipe');
        if (role === 'towel') return bracket('Add a Clean Towel');
        if (role === 'container') return bracket('Add a container');
        if (role === 'lbb') return bracket('Add the Luxe Bamboo Box');
        if (role === 'extra') return bracket('Add an extra');
      }
      var need = Math.max(1, threshold - count);
      if (need === 1) return '[Add 1 item]';
      return '[Add ' + need + ' items]';
    }

    function selectedGifts() {
      return gwpCards.filter(function (card) {
        var btn = card.querySelector('[data-gwp-toggle]');
        return btn && !btn.disabled && btn.classList.contains('gwp--add') && card.getAttribute('data-gwp-variant');
      });
    }
    function giftsPendingLabel(slots, chosen) {
      var remaining = slots - chosen;
      if (remaining === 1) return 'Pick your free gift to continue';
      return 'Pick ' + remaining + ' free gifts to continue';
    }
    function scrollToGwp() {
      var target = document.getElementById('pick-gwp-wrap') || gwpCollection;
      if (!target) return;
      var bar = root.querySelector('.progress-block-wrap');
      var offset = (bar ? bar.offsetHeight : 0) + 12;
      var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }

    function ensureCheckoutButtonStructure() {
      if (!addBtn.querySelector('.cart-button-label')) {
        addBtn.innerHTML = '<span class="cart-button-label"></span><s class="cart-button-was is-empty" aria-hidden="true">&nbsp;</s><span class="cart-button-total is-empty" aria-hidden="true">&nbsp;</span>';
      }
    }

    function setCheckoutButtonContent(labelText, wasAmount, payableAmount, isDisabled) {
      ensureCheckoutButtonStructure();
      var labelEl = addBtn.querySelector('.cart-button-label');
      var wasEl = addBtn.querySelector('.cart-button-was');
      var totalEl = addBtn.querySelector('.cart-button-total');
      if (labelEl) labelEl.textContent = labelText;
      if (wasEl) {
        if (!isDisabled && wasAmount && payableAmount != null && wasAmount > payableAmount) {
          wasEl.textContent = money(wasAmount);
          wasEl.classList.remove('is-empty');
          wasEl.removeAttribute('aria-hidden');
        } else {
          wasEl.textContent = '\u00a0';
          wasEl.classList.add('is-empty');
          wasEl.setAttribute('aria-hidden', 'true');
        }
      }
      if (totalEl) {
        if (!isDisabled && payableAmount != null) {
          totalEl.textContent = money(payableAmount);
          totalEl.classList.remove('is-empty');
          totalEl.removeAttribute('aria-hidden');
        } else {
          totalEl.textContent = '\u00a0';
          totalEl.classList.add('is-empty');
          totalEl.setAttribute('aria-hidden', 'true');
        }
      }
    }

    function renderMiniCart(payable, wasPrice, saveAmount, savePct) {
      if (!miniCart) return;
      miniCart.innerHTML = '';
      var hasItems = false;
      cards.forEach(function (c) {
        var n = qty(c);
        if (n <= 0) return;
        hasItems = true;
        var thumb = document.createElement('div');
        thumb.className = 'mini-cart-thumb';
        thumb.innerHTML = '<img src="' + c.getAttribute('data-image') + '" alt=""><span class="mini-cart-badge">' + n + '</span>';
        miniCart.appendChild(thumb);
      });
      if (emptyCart) emptyCart.hidden = hasItems;
      if (addBtn && payable != null) {
        if (addBtn.classList.contains('is-checkout-redirecting')) return;
        if (addBtn.disabled || addBtn.getAttribute('data-gifts-pending') === 'true') {
          var disabledLabel = labelEmpty;
          if (addBtn.getAttribute('data-gifts-pending') === 'true') {
            disabledLabel = addBtn.getAttribute('data-gifts-pending-label') || 'Pick your free gift to continue';
          }
          setCheckoutButtonContent(disabledLabel, 0, null, true);
        } else {
          var priceHtml = '';
          if (wasPrice && wasPrice > payable) priceHtml += '<s class="cart-button-was">' + money(wasPrice) + '</s>';
          priceHtml += '<span class="cart-button-total">' + money(payable) + '</span>';
          // Same percentage as the TOTAL SAVINGS card: saved amount vs. full "before" value.
          var pct = wasPrice > 0 ? Math.round(saveAmount * 100 / wasPrice) : 0;
          var saveHtml = pct > 0 ? '<span class="cart-button-save">SAVE ' + pct + '%</span>' : '';
          addBtn.innerHTML = '<span class="cart-button-main">' + label + priceHtml + '</span>' + saveHtml;
        }
      }
    }

    // Keep each card's displayed price in sync with the Subscribe & Save toggle. Sub-eligible
    // cards (those with a selling plan) show the discounted sub price with the regular price
    // struck through; one-time reverts to the full price (with any MSRP strike).
    function updateCardPrices() {
      cards.forEach(function (c) {
        var nowEls = c.querySelectorAll('[data-price-now]');
        if (!nowEls.length) return;
        var wasEls = c.querySelectorAll('[data-price-was]');
        var offEls = c.querySelectorAll('[data-price-off]');
        var base = parseInt(c.getAttribute('data-price'), 10) || 0;
        var msrp = parseInt(c.getAttribute('data-msrp'), 10) || base;
        // Real Subscribe & Save price from the variant's selling plan allocation (data-sub-price).
        // Shown only while subscription is active, so the card reverts to full price on one-time.
        var eligible = c.getAttribute('data-sub-display') === 'true';
        var subPrice = parseInt(c.getAttribute('data-sub-price'), 10) || 0;
        var subOn = subActive && eligible && subPrice > 0 && subPrice < base;
        var now, was;
        if (subOn) {
          now = subPrice;
          was = base;
        } else {
          now = base;
          was = msrp;
        }
        var subBadge = c.querySelector('[data-sub-badge]');
        if (subBadge) subBadge.hidden = !subOn;
        var showWas = was > now;
        [].forEach.call(nowEls, function (el) { el.textContent = money(now); });
        [].forEach.call(wasEls, function (el) {
          if (showWas) { el.textContent = money(was); el.hidden = false; }
          else { el.hidden = true; }
        });
        [].forEach.call(offEls, function (el) {
          if (showWas) { el.textContent = Math.round((was - now) * 100 / was) + '%'; el.hidden = false; }
          else { el.hidden = true; }
        });
      });
    }

    function update() {
      updateCardPrices();
      var count = 0, subtotal = 0, msrpTotal = 0, subSavings = 0;
      cards.forEach(function (c) {
        var n = qty(c);
        count += n;
        var cartPrice = parseInt(c.getAttribute('data-cart-price'), 10) || 0;
        var msrp = parseInt(c.getAttribute('data-msrp'), 10);
        if (!msrp) msrp = cartPrice; // no MSRP override (0/empty) → full price is its own MSRP
        subtotal += n * cartPrice;
        msrpTotal += n * msrp;
        // Per-product Subscribe & Save savings — the real gap between the full price and the
        // selling-plan allocation price, counted only while subscription is active. Kept
        // separate from the always-on product markdowns (msrpTotal − subtotal) below.
        if (subActive && c.getAttribute('data-sub-display') === 'true') {
          var sp = parseInt(c.getAttribute('data-sub-price'), 10) || 0;
          if (sp > 0 && sp < cartPrice) subSavings += n * (cartPrice - sp);
        }
        c.classList.toggle('product-selected', n > 0);
      });

      // ── Free-gift set (Gift Logic spec v1.0) ──────────────────────────────────────────────
      // Foundation count (wipes + towels) earns the quantity gifts; a container and an extra each
      // add one on top; the total is capped at 2 and given in fixed order (DermaDot, then Travel).
      var giftResult = computeBybGifts({
        wipeQty: roleQty('murw'),
        towelQty: roleQty('towel'),
        hasContainer: roleQty('container') > 0,
        hasExtra: roleQty('extra') > 0,
        isLuxeBox: hasLbb()
      });
      function isGiftEarned(role) {
        var k = giftKeyForRole(role);
        return !!k && giftResult.gifts.indexOf(k) >= 0;
      }
      // Deterministically select exactly the earned gift cards — they are auto-added, and the pick
      // buttons are inert (see syncGwpToggleBtn / the render pass below).
      gwpCards.forEach(function (card) {
        var abtn = card.querySelector('[data-gwp-toggle]');
        if (!abtn) return;
        var earned = isGiftEarned(card.getAttribute('data-gwp-role')) && !!card.getAttribute('data-gwp-variant');
        if (earned) {
          if (!abtn.classList.contains('gwp--add')) {
            abtn.classList.add('gwp--add');
            card.setAttribute('data-pick-seq', String(++gwpPickSeq));
          }
        } else if (abtn.classList.contains('gwp--add')) {
          abtn.classList.remove('gwp--add');
          card.removeAttribute('data-pick-seq');
        }
      });

      var hasMurw = roleQty('murw') > 0;
      var hasTowel = roleQty('towel') > 0;
      // 2+ wipes waive the Clean Towel requirement (towel becomes optional).
      var towelOk = hasTowel || roleQty('murw') >= 2;
      var foundationReady = hasMurw && towelOk;

      // Only one container total: once one is chosen, block the others.
      var containerChosen = roleQty('container') > 0;
      cards.forEach(function (c) {
        var gated = c.getAttribute('data-requires-foundation') === 'true' && !foundationReady;
        var blocked = c.getAttribute('data-role') === 'container' && containerChosen && qty(c) === 0;
        c.classList.toggle('is-gated', gated);
        c.classList.toggle('is-container-blocked', blocked);
      });

      // subSavings is already 0 when subscription is off, so this covers both toggle states.
      var payable = subtotal - subSavings;

      var giftValue = 0;
      if (towelOk) giftValue += shippingValue; // Free Shipping unlocks with a towel OR 2+ wipes
      // Value of the free gifts the customer actually PICKED (byb3 parity): parse each picked
      // card's real value ("$6", "$15") instead of assuming the travel gift on container-add.
      selectedGifts().forEach(function (card) {
        giftValue += Math.round((parseFloat(String(card.getAttribute('data-gwp-value') || '').replace(/[^0-9.]/g, '')) || 0) * 100);
      });
      giftValue += lbbGiftValue * lbbCount();
      var perceivedSave = Math.max(0, msrpTotal - payable) + giftValue;
      var savePct = msrpTotal + giftValue > 0 ? Math.round((perceivedSave / (msrpTotal + giftValue)) * 100) : 0;
      var saveMax = giftbar ? parseInt(giftbar.getAttribute('data-save-max'), 10) || 60 : 60;
      savePct = Math.min(savePct, saveMax);

      // Keep the {save} token in the heading in sync (falls back to the max % before anything is added).
      if (titleSaveEl) titleSaveEl.textContent = (savePct > 0 ? savePct : saveMax) + '%';


      var pickLabel = giftbar ? (giftbar.getAttribute('data-pick-label') || 'Pick your gift below') : 'Pick your gift below';

      // Number of gifts earned per the spec (0–2). Drives the gift counter and box fills.
      var unlockedSlots = giftResult.totalGifts;

      var unlocked = 0, bonusUnlocked = 0;
      gifts.forEach(function (g) {
        var isSave = g.getAttribute('data-is-save') === 'true';
        var isPickable = g.getAttribute('data-is-pickable') === 'true';
        var role = g.getAttribute('data-unlock-role');
        var threshold = parseInt(g.getAttribute('data-threshold'), 10) || 0;
        // The two gift boxes (DermaDot/Travel) follow the earned-gift set from the spec; the
        // free-shipping and Luxe-bonus boxes keep their own role-based unlock.
        var giftKey = giftKeyForRole(role);
        var on = isSave ? true : (giftKey ? isGiftEarned(role) : isUnlocked(role, threshold, count));

        var celebrate = g.getAttribute('data-celebrate') === 'true';
        var isBonus = g.getAttribute('data-hide-until-unlock') === 'true';
        if (isBonus) {
          // Bonus gift: stays fully hidden (no locked placeholder) until unlocked, then pops in.
          var wasHidden = g.classList.contains('block_hidden');
          g.classList.toggle('block_hidden', !on);
          if (on && wasHidden && celebrate) bybConfetti(g);
        } else {
          var wasLocked = g.classList.contains('block_locked');
          g.classList.toggle('block_locked', !on);
          if (on && wasLocked && celebrate) bybConfetti(g);
        }
        var lockedEl = g.querySelector('[data-gift-locked]');
        var pctEl = g.querySelector('[data-percent-value-gift]');
        var shipEl = g.querySelector('[data-shipping-suffix]');
        var nameEl = g.querySelector('.prog-block-gift-name');

        if (on) {
          if (isBonus) { bonusUnlocked++; } else { unlocked++; }
          if (isSave) {
            var displaySavePct = savePct > 0 ? savePct : saveMax;
            if (pctEl) pctEl.textContent = displaySavePct + '%';
            if (shipEl) shipEl.hidden = !towelOk;
          } else if (nameEl) {
            var unlockedText = g.getAttribute('data-unlocked-text') || pickLabel;
            // The Luxe bonus scales with how many Luxe boxes were added (each = 50 free towels).
            var lbbN = isBonus ? lbbCount() : 1;
            if (isBonus && lbbN > 1) unlockedText = '×' + lbbN + ' ' + unlockedText;
            if (isPickable) {
              nameEl.innerHTML = '<a href="#pick-gwp-wrap">' + unlockedText + '</a>';
            } else {
              nameEl.textContent = unlockedText;
            }
            // Scale the bonus box's struck value (e.g. $18 → $36 for two Luxe boxes).
            var bonusValEl = g.querySelector('[data-gift-value]');
            if (isBonus && bonusValEl && lbbGiftValue > 0) {
              bonusValEl.textContent = lbbN > 0 ? '$' + (lbbGiftValue * lbbN / 100) : '';
            }
          }
        } else if (lockedEl) {
          lockedEl.textContent = lockedHint(g, count);
        }
      });

      if (giftNumEl) giftNumEl.textContent = unlocked;
      if (giftBonusEl) giftBonusEl.textContent = bonusUnlocked > 0 ? ' + ' + bonusUnlocked + ' Bonus' : '';
      // Two sizing bases: --byb-gift-cols follows the visible count (mobile keeps the bigger
      // 3-up size), while --byb-gift-total is the fixed total (desktop uses it so revealing the
      // bonus 3 → 4 doesn't shrink the boxes).
      var visibleGifts = gifts.filter(function (g) { return !g.classList.contains('block_hidden'); }).length;
      if (visibleGifts > 0) root.style.setProperty('--byb-gift-cols', visibleGifts);
      if (gifts.length > 0) root.style.setProperty('--byb-gift-total', gifts.length);
      // Bonus strips (e.g. "+ 50 FREE Clean Towels") join the bar only once their unlock rule is met.
      bonusStrips.forEach(function (strip) {
        var role = strip.getAttribute('data-unlock-role');
        var threshold = parseInt(strip.getAttribute('data-threshold'), 10) || 0;
        strip.classList.toggle('block_hidden', !isUnlocked(role, threshold, count));
      });

      // Gifts are auto-added, so the cards only reflect the earned set — none are pickable.
      var addedCards = gwpCards.filter(function (card) {
        var b = card.querySelector('[data-gwp-toggle]');
        return b && b.classList.contains('gwp--add') && card.getAttribute('data-gwp-variant');
      }).sort(function (a, b) {
        return (parseInt(a.getAttribute('data-pick-seq'), 10) || 0) - (parseInt(b.getAttribute('data-pick-seq'), 10) || 0);
      });
      var chosen = addedCards.length;

      gwpCards.forEach(function (card) {
        var btn = card.querySelector('[data-gwp-toggle]');
        if (!btn) return;
        var isAdded = btn.classList.contains('gwp--add') && !!card.getAttribute('data-gwp-variant');
        btn.disabled = true; // auto-add — no manual pick
        card.classList.toggle('block_locked', !isAdded);
        syncGwpToggleBtn(btn);
      });

      if (gwpCountEl) gwpCountEl.textContent = chosen + '/' + gwpCards.length;
      if (gwpCollection) gwpCollection.classList.toggle('locked', unlockedSlots === 0);
      if (gwpTitleEl) {
        var gwpTitle = unlockedSlots > 0 ? gwpTitleEl.getAttribute('data-title-unlocked') : gwpTitleEl.getAttribute('data-title-locked');
        if (gwpTitle) {
          // "FREE GIFTS" is emphasised (uppercase + bold); the rest stays weight 500.
          var gwpHtml = gwpTitle.replace(/free gifts/ig, '<b class="pick-gwp-free">FREE GIFTS</b>');
          if (gwpTitleEl.innerHTML !== gwpHtml) gwpTitleEl.innerHTML = gwpHtml;
        }
      }

      // Fill each UNLOCKED gift box with a picked gift's photo + name (in order).
      // A locked box keeps its "Add a ___" hint and never shows a picked gift.
      gifts.forEach(function (g) {
        if (g.getAttribute('data-is-pickable') !== 'true' || g.getAttribute('data-is-save') === 'true') return;
        var role = g.getAttribute('data-unlock-role');
        var earned = isGiftEarned(role);
        var img = g.querySelector('.byb-gift-photo');
        var nm = g.querySelector('.prog-block-gift-name');
        var valEl = g.querySelector('[data-gift-value]');
        // Each earned box shows ITS own fixed gift (matched by role), not a fungible pick.
        var pick = null;
        if (earned) {
          for (var pi = 0; pi < gwpCards.length; pi++) {
            if (gwpCards[pi].getAttribute('data-gwp-role') === role && gwpCards[pi].getAttribute('data-gwp-variant')) { pick = gwpCards[pi]; break; }
          }
        }
        if (pick && img) {
          var src = pick.getAttribute('data-gwp-image');
          if (src) {
            if (img.getAttribute('src') !== src) img.setAttribute('src', src);
            g.classList.add('gift-picked');
            var t = pick.querySelector('.gwp-card-title');
            if (nm && t) nm.innerHTML = '<a href="#pick-gwp-wrap">' + t.textContent.trim() + '</a>';
            if (valEl) valEl.textContent = pick.getAttribute('data-gwp-value') || '';
          } else {
            g.classList.remove('gift-picked');
            if (valEl) valEl.textContent = '';
          }
        } else {
          g.classList.remove('gift-picked');
          if (valEl) valEl.textContent = '';
        }
      });

      // Free gifts are auto-picked, so they never block checkout (the customer needn't pick).
      var giftsReady = true;
      var ready = foundationReady && giftsReady;
      addBtn.disabled = !foundationReady;
      addBtn.classList.toggle('is-gifts-pending', foundationReady && !giftsReady);
      if (foundationReady && !giftsReady) {
        addBtn.setAttribute('data-gifts-pending', 'true');
        addBtn.setAttribute('data-gifts-pending-label', giftsPendingLabel(unlockedSlots, chosen));
      } else {
        addBtn.removeAttribute('data-gifts-pending');
        addBtn.removeAttribute('data-gifts-pending-label');
      }
      // "Before" price = everything at full value: products + container/other discounts recovered + free gift value.
      renderMiniCart(payable, payable + perceivedSave, perceivedSave, savePct);

      // Total-savings card (with breakdown), shown above the subscribe block.
      if (savingsLineEl) {
        var discountSavings = Math.max(0, msrpTotal - subtotal); // container / product markdowns
        var subscriptionSavings = subSavings; // per-product Subscribe & Save (0 when off)
        // Split free shipping out of the gift value so it shows as its own line under Free gifts.
        var shippingSavings = (towelOk && shippingValue > 0) ? shippingValue : 0;
        var giftSavings = Math.max(0, giftValue - shippingSavings); // travel + LBB free gifts
        if (ready && perceivedSave > 0) {
          var rows = '';
          if (giftSavings > 0) rows += savingsRow('Free gifts', giftSavings);
          if (shippingSavings > 0) rows += savingsRow('Free shipping', shippingSavings);
          if (discountSavings > 0) rows += savingsRow('Product discounts', discountSavings);
          if (subscriptionSavings > 0) rows += savingsRow('Subscribe &amp; Save', subscriptionSavings);
          var beforePrice = payable + perceivedSave;
          var totalRow = '<div class="byb-savings-total-row"><span>Total</span><span>' +
            (beforePrice > payable ? '<s class="byb-savings-was">' + money(beforePrice) + '</s> ' : '') +
            '<span class="byb-savings-now">' + money(payable) + '</span></span></div>';
          // Percentage saved vs. the full "before" value of this bundle.
          var savingsCardPct = beforePrice > 0 ? Math.round(perceivedSave * 100 / beforePrice) : 0;
          savingsLineEl.innerHTML =
            '<div class="byb-savings-head"><span class="byb-savings-title">TOTAL SAVINGS</span>' +
            '<span class="byb-savings-total">' + money(perceivedSave) + '</span></div>' +
            (rows ? '<div class="byb-savings-rows">' + rows + '</div>' : '') +
            totalRow +
            (savingsCardPct > 0 ? '<p class="byb-savings-pct">You’re saving <b>' + savingsCardPct + '%</b> on this bundle</p>' : '');
          savingsLineEl.hidden = false;
        } else {
          savingsLineEl.hidden = true;
        }
      }

      if (hintEl) {
        if (ready) { hintEl.hidden = true; }
        else {
          hintEl.hidden = false;
          if (!foundationReady) {
            if (!hasMurw && !towelOk) hintEl.textContent = 'Add a Makeup Wipe and a Clean Towel to continue';
            else if (!hasMurw) hintEl.textContent = 'Add a Makeup Wipe to continue';
            else hintEl.textContent = 'Add a Clean Towel to continue';
          } else {
            hintEl.textContent = giftsPendingLabel(unlockedSlots, chosen);
          }
        }
      }

      if (wizardRefresh) wizardRefresh();
      saveState();
    }

    cards.forEach(function (card) {
      var val = card.querySelector('[data-qval]');
      var inc = card.querySelector('[data-inc]');
      var max = parseInt(card.getAttribute('data-max'), 10) || 0;
      card.setAttribute('data-qty', '0');
      // Silent setter used by session restore — updates the card without triggering a full update().
      card._setQtySilent = function (n) {
        n = Math.max(0, n);
        if (max > 0 && n > max) n = max;
        card.setAttribute('data-qty', n);
        val.textContent = n;
        if (inc) inc.disabled = (max > 0 && n >= max);
      };
      function set(n) {
        card._setQtySilent(n);
        update();
      }
      // Blocked containers (another already chosen) and foundation-gated cards can't be added.
      function blockedAdd() { return card.classList.contains('is-gated') || card.classList.contains('is-container-blocked'); }
      var addBtnEl = card.querySelector('[data-add-btn]');
      if (addBtnEl) addBtnEl.addEventListener('click', function (e) {
        e.stopPropagation();
        if (blockedAdd()) return;
        set(qty(card) + 1); // first add → qty 1, which reveals the quantity stepper
      });
      card.querySelector('[data-dec]').addEventListener('click', function (e) {
        e.stopPropagation();
        if (card.classList.contains('is-gated')) return;
        set(qty(card) - 1);
      });
      inc.addEventListener('click', function (e) {
        e.stopPropagation();
        if (blockedAdd()) return;
        set(qty(card) + 1);
      });
    });

    root.querySelectorAll('.nc-modal-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var id = trigger.getAttribute('data-nc-target');
        var modal = id ? root.querySelector('#' + id) : null;
        if (modal) {
          // Re-parent to the section root so `position: fixed` resolves against the
          // viewport (an active step panel's transform would otherwise trap it).
          if (modal.parentNode !== root) root.appendChild(modal);
          modal.classList.add('is-open');
        }
      });
    });
    root.querySelectorAll('.nc-modal-close').forEach(function (close) {
      close.addEventListener('click', function () {
        var id = close.getAttribute('data-nc-target');
        var modal = id ? root.querySelector('#' + id) : close.closest('.nc-modal-overlay');
        if (modal) modal.classList.remove('is-open');
      });
    });
    root.querySelectorAll('.nc-modal-overlay').forEach(function (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) overlay.classList.remove('is-open');
      });
    });
    // Esc closes whichever modal is currently open.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.keyCode !== 27) return;
      root.querySelectorAll('.nc-modal-overlay.is-open').forEach(function (m) { m.classList.remove('is-open'); });
    });

    root.querySelectorAll('[data-modal-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      var thumbs = [].slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
      if (!main || !thumbs.length) return;
      var current = 0;

      function show(index) {
        var count = thumbs.length;
        current = (index + count) % count;
        main.src = thumbs[current].getAttribute('data-full');
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === current); });
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { show(i); });
      });

      var prev = gallery.querySelector('[data-gallery-prev]');
      var next = gallery.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); show(current - 1); });
      if (next) next.addEventListener('click', function (e) { e.stopPropagation(); show(current + 1); });
      // Initialize on load so `current`, the main image and the active thumb are in sync
      // from the very first open (prevents next/prev getting out of step on first use).
      show(0);
    });

    root.querySelectorAll('.byb-tab-trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tab = btn.closest('.byb-tab');
        if (!tab) return;
        var open = tab.classList.toggle('is-open');
        var panel = tab.querySelector('.byb-tab-panel');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (panel) panel.hidden = !open;
      });
    });

    gwpCards.forEach(function (card) {
      var btn = card.querySelector('[data-gwp-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var nowAdded = !btn.classList.contains('gwp--add');
        btn.classList.toggle('gwp--add');
        // Stamp the pick order so the gift boxes fill in selection order, not DOM order.
        // Remember a manual removal so auto-pick doesn't immediately re-add it.
        if (nowAdded) { card.setAttribute('data-pick-seq', String(++gwpPickSeq)); card._userRemoved = false; }
        else { card.removeAttribute('data-pick-seq'); card._userRemoved = true; }
        syncGwpToggleBtn(btn);
        update();
      });
    });

    if (subWrap) {
      subWrap.querySelectorAll('input[type=radio]').forEach(function (r) {
        r.addEventListener('change', function () {
          subActive = r.value === 'sub';
          update();
        });
      });
    }

    addBtn.addEventListener('click', function () {
      if (addBtn.getAttribute('data-gifts-pending') === 'true') {
        scrollToGwp();
        return;
      }
      var items = [];
      // Free Shipping is earned with a Clean Towel OR 2+ wipes. Since the towel may now be skipped,
      // flag the wipe lines with _byb_freeship (parity with _byb_gift) so the server function that
      // grants free shipping can key off it instead of only the towel line.
      var freeShipEarned = roleQty('towel') > 0 || roleQty('murw') >= 2;
      cards.forEach(function (c) {
        var n = qty(c);
        if (n > 0) {
          // Tag each line with its bundle role so the discount function can enforce
          // unlock rules server-side. Featured Luxe Bamboo containers get 'lbb'.
          var bybRole = c.getAttribute('data-role') || 'extra';
          if (bybRole === 'container' && c.getAttribute('data-featured') === 'true') bybRole = 'lbb';
          var itProps = { _byb: bybRole };
          if (bundleId) itProps.Bundle = bundleId;
          if (freeShipEarned && bybRole === 'murw') itProps._byb_freeship = 'true';
          var it = { id: parseInt(c.getAttribute('data-variant-id'), 10), quantity: n, properties: itProps };
          // On Subscribe & Save, attach each product's OWN selling plan (only if it has one).
          if (subActive) {
            var sp = c.getAttribute('data-selling-plan');
            if (sp) it.selling_plan = parseInt(sp, 10);
          }
          items.push(it);
        }
      });
      if (!items.length) return;
      // Add gifts in the fixed spec order — gift #1 DermaDot, then gift #2 Travel.
      var giftOrder = { dermadot: 0, travel: 1 };
      selectedGifts().sort(function (a, b) {
        return (giftOrder[giftKeyForRole(a.getAttribute('data-gwp-role'))] || 0) - (giftOrder[giftKeyForRole(b.getAttribute('data-gwp-role'))] || 0);
      }).forEach(function (card) {
        // Free gifts are always one-time — never attach a selling plan, even on Subscribe & Save.
        var giftProps = { _byb: 'gift', _byb_gift: 'true' };
        if (bundleId) giftProps.Bundle = bundleId;
        items.push({
          id: parseInt(card.getAttribute('data-gwp-variant'), 10),
          quantity: 1,
          properties: giftProps
        });
      });
      addBtn.disabled = true;
      addBtn.classList.add('is-checkout-redirecting');
      var checkoutLabel = addBtn.querySelector('.cart-button-label');
      if (checkoutLabel) checkoutLabel.textContent = 'Redirecting…';
      // Lock the subscribe / one-time toggle too while the checkout redirect is in progress.
      setSubDisabled(true);
      // Start from an empty cart so only the freshly-built bundle is checked out.
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () {
          // Keep the saved bundle state — if the customer comes back from checkout,
          // their selections are restored. The cart itself was already cleared + rebuilt.
          // Re-enable the button BEFORE redirecting: if the customer navigates back, the
          // bfcache snapshot would otherwise leave it stuck disabled on "Redirecting…".
          addBtn.classList.remove('is-checkout-redirecting');
          addBtn.disabled = false;
          setSubDisabled(false);
          update();
          try { window.sessionStorage.setItem(RETURN_KEY, '1'); } catch (e) {}
          window.location.href = discountCode ? ('/discount/' + discountCode + '?redirect=/checkout') : '/checkout';
        })
        .catch(function () {
          addBtn.classList.remove('is-checkout-redirecting');
          addBtn.disabled = false;
          setSubDisabled(false);
          update();
          alert('Sorry, something went wrong adding your bundle. Please try again.');
        });
    });

    // ---- Wizard: guided step-by-step navigation ----
    var wizard = root.querySelector('[data-wizard]');
    if (wizard) {
      var panels = [].slice.call(wizard.querySelectorAll('[data-step-panel]'));
      // Step dots live above the gift bar (outside the wizard), so query from root.
      var dots = [].slice.call(root.querySelectorAll('[data-step-dot]'));
      var isAccordion = root.classList.contains('byb-nav-tabs');
      var current = 0;
      // Accordion: show ALL steps from the start (no progressive reveal).
      var maxReached = isAccordion ? panels.length : 0;

      function panelSelectedCount(panel) {
        var n = 0;
        [].forEach.call(panel.querySelectorAll('.nc-product-card'), function (c) { n += qty(c); });
        return n;
      }
      // Role of a step, taken from the products it contains (e.g. the Clean Towel step holds
      // data-role="towel" cards).
      function panelRole(panel) {
        var c = panel && panel.querySelector('.nc-product-card[data-role]');
        return c ? c.getAttribute('data-role') : null;
      }
      // A step is satisfied when it's optional, or when at least one of its products is selected.
      function panelSatisfied(panel) {
        if (!panel) return true;
        if (panel.getAttribute('data-step-required') !== 'true') return true;
        // New: the Clean Towel step stops being required once 2+ wipes are chosen.
        if (panelRole(panel) === 'towel' && roleQty('murw') >= 2) return true;
        return panelSelectedCount(panel) > 0;
      }
      // Can only move forward once every required step before the target is satisfied.
      function canReach(target) {
        for (var i = 0; i < target && i < panels.length; i++) {
          if (!panelSatisfied(panels[i])) return false;
        }
        return true;
      }
      function scrollToWizardTop() {
        var bar = root.querySelector('.progress-block-wrap');
        var barH = bar ? bar.offsetHeight : 0;
        // Accordion: focus the newly opened step (its header); stepper: top of the wizard.
        var target = wizard;
        if (isAccordion && panels[current]) {
          target = panels[current].querySelector('.byb-step-panel-head') || panels[current];
        }
        // Extra top gap so the previous step stays partly visible above the opened one (esp. mobile).
        var y = target.getBoundingClientRect().top + window.pageYOffset - barH - 72;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      }
      function refresh() {
        dots.forEach(function (dot) {
          var idx = parseInt(dot.getAttribute('data-step-dot'), 10);
          var done = idx < current && panelSatisfied(panels[idx]);
          dot.classList.toggle('is-active', idx === current);
          dot.classList.toggle('is-done', done);
          dot.classList.toggle('is-reachable', idx <= current || canReach(idx));
        });
        // Accordion: every step is expanded, but steps whose prerequisites aren't met stay locked
        // (non-interactive) so their products can't be selected — e.g. Clean Towels can't be added
        // until a Clean Wipe is chosen. The lock clears the moment the prerequisite is met.
        if (isAccordion) {
          panels.forEach(function (p, idx) {
            var locked = idx !== 0 && !canReach(idx);
            p.classList.toggle('byb-step-locked', locked);
          });
        }
        var panel = panels[current];
        if (!panel) return;
        var backBtn = panel.querySelector('[data-step-back]');
        if (backBtn) backBtn.style.display = current === 0 ? 'none' : '';
        var nextBtn = panel.querySelector('[data-step-next]');
        if (nextBtn) {
          var sel = panelSelectedCount(panel);
          // Unsatisfied required step (accounts for the 2+ wipes towel waiver) blocks Continue.
          if (!panelSatisfied(panel)) {
            nextBtn.disabled = true;
            nextBtn.textContent = 'Continue';
          } else {
            nextBtn.disabled = false;
            nextBtn.textContent = sel === 0 ? 'Skip' : 'Continue';
          }
        }
        var checkoutBtn = panel.querySelector('[data-step-checkout]');
        if (checkoutBtn) {
          var lastIdx = panels.length - 1;
          // Only offer "Skip to checkout" once the required steps are behind us — i.e. any
          // required step still at/after the current one means skipping isn't allowed yet.
          var canSkip = true;
          for (var i = 0; i <= current && i < panels.length; i++) {
            if (!panelSatisfied(panels[i])) { canSkip = false; break; }
          }
          var requiredAhead = false;
          for (var j = current; j < lastIdx; j++) {
            if (!panelSatisfied(panels[j])) { requiredAhead = true; break; }
          }
          // Show on every optional step once required steps are done (steps 3 & 4), incl. the last one.
          checkoutBtn.style.display = requiredAhead ? 'none' : '';
          checkoutBtn.disabled = !canSkip;
        }
      }
      function showStep(i, doScroll) {
        i = Math.max(0, Math.min(panels.length - 1, i));
        if (i > current && !canReach(i)) i = current; // don't let required steps be skipped
        current = i;
        if (i > maxReached) maxReached = i;
        panels.forEach(function (p, idx) {
          p.classList.toggle('is-active', idx === i); // header highlight = current step
          if (isAccordion) {
            // All steps expanded by default; the non-active ones are just dimmed (CSS), never
            // collapsed. is-open is additive — every panel stays open.
            p.classList.add('is-open');
            if (idx === i) p.classList.remove('byb-collapsed'); // ensure the target is expanded
            p.classList.toggle('byb-step-hidden', idx > maxReached);
          } else {
            p.classList.remove('byb-collapsed'); // stepper: navigating opens the target step
          }
        });
        refresh();
        if (doScroll) scrollToWizardTop();
      }
      wizardRefresh = refresh;
      wizardGoToLast = function () { showStep(panels.length - 1, false); };

      var accordion = root.classList.contains('byb-nav-tabs');
      var autoAdvance = root.getAttribute('data-auto-advance') === 'true';
      panels.forEach(function (panel, panelIdx) {
        var nextBtn = panel.querySelector('[data-step-next]');
        var backBtn = panel.querySelector('[data-step-back]');
        if (nextBtn) nextBtn.addEventListener('click', function () { showStep(current + 1, true); });
        if (backBtn) backBtn.addEventListener('click', function () { showStep(current - 1, true); });
        // Auto-advance: clicking Add on a product in the current step jumps to the next step
        // (no Continue click needed). Only from the current, non-last step once it's satisfied.
        if (autoAdvance) {
          panel.querySelectorAll('[data-add-btn]').forEach(function (btn) {
            btn.addEventListener('click', function () {
              if (panelIdx !== current || current >= panels.length - 1) return;
              // Let the add (qty change) apply first, then advance if the step is now satisfied.
              setTimeout(function () {
                if (panelIdx === current && panelSatisfied(panels[current]) && canReach(current + 1)) {
                  showStep(current + 1, true);
                }
              }, 100);
            });
          });
        }
        var checkoutBtn = panel.querySelector('[data-step-checkout]');
        if (checkoutBtn) checkoutBtn.addEventListener('click', function () { showStep(panels.length - 1, true); });
        // Accordion (multi-open): clicking an already-open step just collapses/expands that one
        // (others stay open); clicking a closed, reachable step opens it.
        if (accordion) {
          var head = panel.querySelector('.byb-step-panel-head');
          if (head) head.addEventListener('click', function () {
            if (panel.classList.contains('is-open')) {
              panel.classList.toggle('byb-collapsed');
            } else if (panelIdx <= current || canReach(panelIdx)) {
              showStep(panelIdx, true);
            }
          });
        }
      });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = parseInt(dot.getAttribute('data-step-dot'), 10);
          if (idx <= current || canReach(idx)) showStep(idx, true);
        });
      });

      // Accordion: scroll-spy. As the customer scrolls, select the step whose header has crossed
      // ~45% of the viewport (multi-open, so nothing collapses and scrolling is never fought).
      // Scrolling down opens the next step once its prerequisites are met; scrolling up simply
      // re-selects the step above.
      if (accordion) {
        var scrollRaf = null;
        window.addEventListener('scroll', function () {
          if (scrollRaf) return;
          scrollRaf = requestAnimationFrame(function () {
            scrollRaf = null;
            var bar = root.querySelector('.progress-block-wrap');
            var barH = bar ? bar.offsetHeight : 0;
            var threshold = barH + Math.round((window.innerHeight - barH) * 0.45);
            var target = -1;
            for (var i = 0; i < panels.length; i++) {
              var h = panels[i].querySelector('.byb-step-panel-head');
              if (h && h.getBoundingClientRect().top <= threshold) target = i;
            }
            if (target < 0 || target === current) return;
            if (target > current && !canReach(target)) return; // don't skip a still-unmet required step
            showStep(target, false); // no scroll compensation — multi-open never collapses
          });
        }, { passive: true });
      }
      // Gift-bar "pick your gift" links jump straight to the review step. Delegated because
      // update() regenerates those anchors via innerHTML, so per-element listeners wouldn't stick.
      root.addEventListener('click', function (e) {
        var link = e.target.closest && e.target.closest('a[href="#pick-gwp-wrap"]');
        if (link && root.contains(link)) { e.preventDefault(); showStep(panels.length - 1, true); }
      });

      showStep(0, false);
    }

    // Re-apply any bundle the customer built before refreshing, then render once.
    restoreState();
    update();

    // Returning from checkout: open the last (review) step rather than step 1. Only fires when
    // the flag was set on the way to checkout, and only once (cleared after use).
    try {
      if (window.sessionStorage.getItem(RETURN_KEY) === '1') {
        window.sessionStorage.removeItem(RETURN_KEY);
        if (wizardGoToLast) wizardGoToLast();
      }
    } catch (e) {}
  }

  function initAll() {
    document.querySelectorAll('.build-your-bundle').forEach(initByb);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init in the theme editor when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.build-your-bundle');
    if (root) initByb(root);
  });
})();
